module.exports = __webpack_public_path__ + "img/powerpoint.1dc87b46.svg";